// figureConverter als Hilfsfunktion, keine React-Komponente
const figureConverter = (amount, showCents) => {
    const options = {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: showCents ? 2 : 0,
        maximumFractionDigits: showCents ? 2 : 0,
    };

    return new Intl.NumberFormat('de-DE', options).format(amount);
};

export default figureConverter;
